// ============================================================================
// BUBBLE SORT - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'bubble-sort',
  name: 'Bubble Sort',
  category: 'Sorting',
  complexity: {
    time: 'O(n²) average/worst, O(n) best',
    space: 'O(1)'
  },
  description: 'A simple comparison-based sorting algorithm that repeatedly steps through the list, compares adjacent elements, and swaps them if they are in the wrong order. The pass through the list is repeated until the list is sorted.'
};
